module.exports = __webpack_public_path__ + "img/cloudSync.e68c950e.png";